import { Card, CardContent } from "@/components/ui/card";
import { BRAND_NAME } from "@/constants/brand";
import {
  Stethoscope,
  Activity,
  MessageCircle,
  ShieldCheck,
  Tag,
  Clock,
} from "lucide-react";

const items = [
  {
    icon: Stethoscope,
    title: "Unlimited free consults",
    desc: "Walk into any 1Rupee Clinic and consult our GPs and specialists at zero cost for the whole year.",
  },
  {
    icon: Tag,
    title: "Flat 10% off diagnostics",
    desc: "Save on every blood test, ECG, X-Ray, sonography, CT scan and MRI — stacked across the family.",
  },
  {
    icon: MessageCircle,
    title: "Instant on WhatsApp",
    desc: "Receive your printable single-side card on WhatsApp plus an SMS receipt the moment you pay.",
  },
  {
    icon: ShieldCheck,
    title: "Secure Razorpay payment",
    desc: "Pay ₹100 once via UPI, card, wallet or net-banking. PCI-DSS secured. No hidden charges.",
  },
  {
    icon: Clock,
    title: "Activated in 30 seconds",
    desc: "Skip queues and paperwork. Membership is auto-generated with a unique alphanumeric ID.",
  },
  {
    icon: Activity,
    title: "Works across 18+ clinics",
    desc: "Use your card at every 1Rupee Clinic location, diagnostic centre and partner pharmacy.",
  },
];

export const Benefits = () => {
  return (
    <section id="benefits" className="relative py-20 sm:py-28">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl">
          <div className="text-xs font-semibold uppercase tracking-[0.18em] text-primary mb-3">
            Why join
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-foreground">
            One card. <span className="text-gradient-aqua">Real savings.</span>
          </h2>
          <p className="mt-4 text-muted-foreground text-base sm:text-lg">
            Built for families that visit clinics 3+ times a year. Your
            membership pays for itself with a single test.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map(({ icon: Icon, title, desc }, idx) => (
            <Card
              key={title}
              className="group relative overflow-hidden border-border/70 hover:border-primary/30 hover:shadow-elegant transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 bg-card"
            >
              <div className="absolute top-0 right-0 h-32 w-32 bg-aqua-glow opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <CardContent className="relative p-6 flex flex-col h-full">
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-primary/10 text-primary group-hover:bg-gradient-primary group-hover:text-primary-foreground transition-colors duration-300">
                  <Icon className="h-5 w-5" />
                </span>
                <h3 className="mt-5 font-display font-semibold text-lg text-foreground">
                  {title}
                </h3>
                <p className="mt-2 text-sm text-muted-foreground leading-relaxed">
                  {desc}
                </p>
                <div className="mt-auto pt-5 text-[11px] font-mono text-muted-foreground/70">
                  / {String(idx + 1).padStart(2, "0")}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;
